import { render, staticRenderFns } from "./NotifDialog.vue?vue&type=template&id=6abe1f6a"
import script from "./NotifDialog.vue?vue&type=script&lang=js"
export * from "./NotifDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports